import { render, staticRenderFns } from "./LastProductsVisitedComponent.vue?vue&type=template&id=3cf51800"
import script from "./LastProductsVisitedComponent.vue?vue&type=script&lang=js"
export * from "./LastProductsVisitedComponent.vue?vue&type=script&lang=js"
import style0 from "./LastProductsVisitedComponent.vue?vue&type=style&index=0&id=3cf51800&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports